import React from 'react';

import { HStack, Icon, Text } from '@wegroup/design-system';

interface Props {
  label: string;
}

const AddressSearchInfo: React.FC<React.PropsWithChildren<Props>> = ({
  label,
}) => {
  return (
    <HStack>
      <Icon color="gray.300" name="IconInfoFilled" />
      <Text color="gray.300" fontSize="sm" maxW="96">
        {label}
      </Text>
    </HStack>
  );
};

export default AddressSearchInfo;
